import { defineGetActionsPrSu } from '../../actionsHelper'

const actions = {}
defineGetActionsPrSu(actions, 'GET_UTILITY_TIMEOFDAYDATA', 'getTimeOfDayData')
export default actions
